<template>
  <div class="multiselect multiselect--space-evenly">
    <MultiselectCheckbox
      v-for="(service, index) in services"
      :key="index"
      :val="index"
      v-model="servicesState"
    >
      <b>{{ service.name }}</b>
      <p>{{ service.text }}</p>
    </MultiselectCheckbox>
  </div>
</template>

<script>
import MultiselectCheckbox from "./MultiselectCheckbox.vue";

export default {
  components: {
    MultiselectCheckbox
  },
  data() {
    return {
      services: this.$t("depotfinder.services.services")
    };
  },

  computed: {
    servicesState: {
      get() {
        return this.$store.getters.getServicesState;
      },
      set(value) {
        this.$store.dispatch("updateServicesState", value);
      }
    }
  },

  mounted() {}
};
</script>
